"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRadio = exports.StyledMenu = exports.ArrowDown = exports.StyledButton = exports.StyledLabel = exports.TimeOfDayContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const button_1 = __importDefault(require("@kyruus/button"));
const radio_1 = __importDefault(require("@kyruus/radio"));
const ui_theme_1 = require("@kyruus/ui-theme");
const menu_1 = __importDefault(require("@kyruus/menu"));
exports.TimeOfDayContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  width: 100%;
`;
exports.StyledLabel = styled_1.default.label `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin: 0;
`;
exports.StyledButton = (0, styled_1.default)(button_1.default) `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  background: ${(0, ui_theme_1.fromTheme)('color_background')};

  &:hover {
    background: transparent;
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
  }

  &:active {
    background: transparent;
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_link')};
    color: ${(0, ui_theme_1.fromTheme)('text_color')};
  }

  &:active:not(:disabled) {
    border: none;
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_link')};
    background: transparent;
  }

  &:focus {
    background: transparent;
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_link')};
  }
`;
exports.ArrowDown = (0, styled_1.default)('span') `
  display: flex;
  align-items: center;
`;
exports.StyledMenu = (0, styled_1.default)(menu_1.default) `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  width: ${({ anchorEl }) => (anchorEl ? `${anchorEl.clientWidth}px` : '0')};

  div.MuiPaper-root {
    width: inherit;
    min-width: inherit;
    max-width: inherit;
    overflow-y: auto;
  }

  ul {
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;
exports.StyledRadio = (0, styled_1.default)(radio_1.default) `
  & {
    .MuiFormControlLabel-root,
    [class*='MuiFormControlLabel-root'] {
      display: inline;
      padding-top: 0;
      padding-bottom: 0;

      > [class*='MuiRadio-root'] {
        padding-top: 6px;
        padding-bottom: 6px;
        padding-left: 9px;
        padding-right: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
      }
    }

    .MuiFormControlLabel-label,
    [class*='MuiFormControlLabel-label'] {
      font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
    }

    .MuiSvgIcon-root,
    [class*='MuiSvgIcon-root'] {
      font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_3')};
    }
  }
`;
//# sourceMappingURL=styles.js.map